
import '../owner/owner.css';
import './pl_landlord.css';
import StayReview from '../owner/widgets/stay-review.vue';

export default {
  name: 'pl-landlord-owner-stay-queue',
  components: {
    StayReview: StayReview
  },
  data: function () {
    return {
      loading: false,
      items: [],
      currentStay: null,
      ui: {
        review: false
      }
    };
  },
  created: function () {
    this.loadList();
  },
  methods: {
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    toastFail: function (status) {
      if (status == -5) this.toast('未ログイン');
      else if (status == -6) this.toast('権限がありません');
      else this.toast('取得に失敗しました');
    },
    loadList: function () {
      var t = this;
      t.loading = true;
      axios.get('ownerStay', { params: { status: 'pending' } }).then(function (res) {
        t.loading = false;
        if (res.data.status != 1) {
          t.toastFail(res.data.status);
          t.items = [];
          return;
        }
        t.items = (res.data.options && res.data.options.items) || [];
      }).catch(function () {
        t.loading = false;
        t.toast('通信に失敗しました');
        t.items = [];
      });
    },
    stayRange: function (item) {
      if (!item) return '';
      var a = item.stay_date ? String(item.stay_date).substr(0, 10) : '';
      var b = item.date_to ? String(item.date_to).substr(0, 10) : a;
      if (!a) return '';
      if (!b || b === a) return a;
      return a + '〜' + b;
    },
    openReview: function (item) {
      this.currentStay = item;
      this.ui.review = true;
    },
    onDone: function () {
      this.currentStay = null;
      this.loadList();
    }
  }
};
